import { Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { AlarmUserGroupChangeRecordField, IActivityLog, IAlarmUserGroupChangeRecord } from 'app/models/activity-log.model';
import { IdentityFormatPipe, IncludesPipe, MomentPipe, SomePipe } from 'app/pipes/pipes';

@Component({
    selector: 'app-activity-receiver-group-details',
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        IdentityFormatPipe,
        IncludesPipe,
        MomentPipe,
        SomePipe
    ],
    templateUrl: './activity-receiver-group-details.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['../activity-details-dialog/activity-details-content-styles.css']
})
export class ActivityReceiverGroupDetailsComponent implements OnChanges {
  @Output() closeDialog = new EventEmitter<void>();
  @Input() log: IActivityLog;
  @Input() locations: Location[] = [];

  alarmUserGroupChanges: IAlarmUserGroupChangeRecord;
  visibleFields: AlarmUserGroupChangeRecordField[] = [];

 ngOnChanges(): void {
    this.alarmUserGroupChanges = this.log?.details?.alarmUserGroupChanges;
    const result = this.getVisibleFields(this.alarmUserGroupChanges);
    this.visibleFields = [...result.visibleFields]; 
  }

  private getVisibleFields(alarmUserGroupChanges: IAlarmUserGroupChangeRecord): { visibleFields: AlarmUserGroupChangeRecordField[] } {
    if (!alarmUserGroupChanges) {
      return { visibleFields: [] };
    }
  
    const fields: AlarmUserGroupChangeRecordField[] = [];
  
    (['groupName', 'locked'] as const).forEach((key) => {
      const change = alarmUserGroupChanges[key];
      if (!change) return;
  
      const oldVal = change.oldValue;
      const newVal = change.newValue;
  
      if (oldVal !== newVal) {
        fields.push(key);
      }
    });
  
    if (alarmUserGroupChanges.addedStaffs?.length) {
      fields.push('addedStaffs');
    }
  
    if (alarmUserGroupChanges.removedStaffs?.length) {
      fields.push('removedStaffs');
    }
  
    return { visibleFields: fields };
  }
  
  getHiddenStaffCount(added: any[], removed: any[]): number {
    const addedLength = added?.length || 0;
    const removedLength = removed?.length || 0;
    const totalShown = 15;
    const total = addedLength + removedLength;
    return total > totalShown ? total - totalShown : 0;
  } 

  getVisibleStaffItems(added: any[], removed: any[]) {
    const addedItems = added || [];
    const removedItems = removed || [];
  
    const totalCount = addedItems.length + removedItems.length;
    const visibleCount = 15;
    const newVisibleCount = Math.min(visibleCount, totalCount);
  
    const visibleAdded = Math.min(addedItems.length, newVisibleCount);
    const visibleRemoved = newVisibleCount - visibleAdded;
  
    const hiddenCount = totalCount - newVisibleCount;
  
    return { visibleAdded, visibleRemoved, hiddenCount };
  }
}
  